/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:7f143dcd-08f9-45b0-b83b-b8b1d02f283f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_dXCh6yPNV",
    "aws_user_pools_web_client_id": "m9cfmqd6d6ij9famiv7vojmhe",
    "oauth": {
        "domain": "factorioui455fb7e6-455fb7e6-main.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://factorio.rhee.io/,http://localhost:3000/",
        "redirectSignOut": "https://factorio.rhee.io/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "factorioui-20220313174238-hostingbucket-main",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d3qk1u15si0i0o.cloudfront.net"
};


export default awsmobile;
